import BaseOption from "%/dynamic-component-editor/classes/base-option";
import { inspectorTools } from "%/dynamic-component-editor/inspector/inspector-tool-map";

// Card-vs-store saving badge; {discount} is the whole-percent saving, hidden at 0.
export default class DiscountText extends BaseOption {
  static userInterfaceComponent = {
    label: "Discount Label",
    component: inspectorTools.SIMPLE_INPUT,
  };

  static defaultValue = "save {discount}%";
}
